import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

// Substitui o filtro `markdown` do legado (marked.parse + $sce.trustAsHtml, que
// renderizava qualquer HTML vindo do agente). react-markdown não interpreta HTML
// cru por padrão; remark-gfm mantém as tabelas e listas que o marked já aceitava.
// Estilos portados do <style> de chat.html (.agente-chat-msg-markdown).
const COMPONENTES: Components = {
  p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
  ul: ({ children }) => <ul className="mb-2 ml-5 list-disc space-y-0.5">{children}</ul>,
  ol: ({ children }) => <ol className="mb-2 ml-5 list-decimal space-y-0.5">{children}</ol>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
  h1: ({ children }) => <h3 className="mb-1 mt-2.5 font-semibold">{children}</h3>,
  h2: ({ children }) => <h3 className="mb-1 mt-2.5 font-semibold">{children}</h3>,
  h3: ({ children }) => <h3 className="mb-1 mt-2.5 font-semibold">{children}</h3>,
  a: ({ children, href }) => (
    <a href={href} target="_blank" rel="noreferrer" className="text-primary underline">
      {children}
    </a>
  ),
  pre: ({ children }) => (
    <pre className="my-2 overflow-x-auto rounded-md border border-border bg-muted p-2.5 text-xs [&_code]:bg-transparent [&_code]:p-0">{children}</pre>
  ),
  code: ({ children }) => <code className="rounded bg-muted px-1 py-px text-xs">{children}</code>,
  table: ({ children }) => (
    <div className="my-2 overflow-x-auto">
      <table className="w-full border-collapse text-xs">{children}</table>
    </div>
  ),
  th: ({ children }) => <th className="border border-border bg-muted px-2 py-1 text-left font-semibold">{children}</th>,
  td: ({ children }) => <td className="border border-border px-2 py-1">{children}</td>,
};

export function Markdown({ children }: { children: string }) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={COMPONENTES}>
      {children}
    </ReactMarkdown>
  );
}
